import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Warehouse {
    name: string;
    address: string;
}

/**
 * Catálogo de almacenes y almacén seleccionado.
 *
 * Vive en un servicio y no en el DashboardComponent porque el selector del
 * header y las pantallas hijas (KPI's de almacén) tienen que mirar la misma
 * selección; si cada uno guardara la suya se desincronizarían al cambiarla.
 *
 * Direcciones de relleno: todavía no hay catálogo de almacenes en el backend.
 */
@Injectable({ providedIn: 'root' })
export class WarehouseService {
    readonly warehouses: Warehouse[] = [
        { name: 'Almacén 109', address: 'Carr. Miguel Alemán Km 24, Apodaca, Nuevo Leon, 66600' },
        { name: 'Monterrey', address: 'Carr. Miguel Alemán Km 24, Apodaca, Nuevo Leon, 66600' },
        { name: 'Almacén 110', address: 'Carr. Miguel Alemán Km 24, Apodaca, Nuevo Leon, 66600' }
    ];

    private readonly currentSubject = new BehaviorSubject<Warehouse>(this.warehouses[0]);

    /** Emite el almacén activo; repite el último valor a quien se suscriba tarde. */
    readonly current$ = this.currentSubject.asObservable();

    get current(): Warehouse {
        return this.currentSubject.value;
    }

    select(warehouse: Warehouse): void {
        if (warehouse === this.currentSubject.value) return;
        this.currentSubject.next(warehouse);
    }

    /** El almacén actual primero: es el orden en que lo pinta el desplegable. */
    sorted(): Warehouse[] {
        const current = this.currentSubject.value;
        return [current, ...this.warehouses.filter(w => w !== current)];
    }
}
